import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  helpText: {
    defaultMessage: 'Please enter the SMS code that was sent to your mobile device.',
    id: 'SmsCodeTemplate.helpText',
  },
  title: {
    defaultMessage: 'Enter SMS code',
    id: 'SmsCodeTemplate.title',
  },
});
